<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* #app height/overflow rules live in src/assets/css/base.css.
   Auth pages add 'auth-page' class to <html> to unlock page scroll. */
</style>
